<template>
  <div>
    <div class="inner-header">
      <nav class="navbar fixed-top animate__animated animate__slideInRight">
        <a @click="$router.go(-1)" class="back-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
            <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
              <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2" />
              <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2" />
            </g>
          </svg>
        </a>
        <a href="" class="link-title">{{GetBrokerDetails.firm_name && GetBrokerDetails.firm_name ? GetBrokerDetails.firm_name:'Broker Details'}}</a>
      </nav>
    </div>
    <div class="inner-page animate__animated animate__slideInRight">
      <div class="container-fluid">
        <div class="row">
          <!-- Enquiry Card -->
          <div class="col-12">
            <div class="card details-card">
              <div class="card-header">
                <div class="row">
                  <div class="col-7">
                    <span class="lead-title" v-if="GetBrokerDetails.name">{{GetBrokerDetails.name}}</span>
                    <span class="sub-title" v-if="GetBrokerDetails.firm_name">{{GetBrokerDetails.firm_name}}</span>
                  </div>
                  <div class="col-5 text-right" v-if="GetBrokerDetails.status">
                    <span class="label-status">{{GetBrokerDetails.status}}</span>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6" v-if="GetBrokerDetails.assigned_to">
                    <span class="enq-title">Assigned to</span>
                    <span class="enq-details">{{GetBrokerDetails.assigned_to}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.locality_name">
                    <span class="enq-title">Locality</span>
                    <span class="enq-details">{{GetBrokerDetails.locality_name}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.performance">
                    <span class="enq-title">Performance</span>
                    <span class="enq-details">{{GetBrokerDetails.performance}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.categorization">
                    <span class="enq-title">Categorization</span>
                    <span class="enq-details">{{GetBrokerDetails.categorization}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.meeting_executive">
                    <span class="enq-title">Meeting Executive.</span>
                    <span class="enq-details">{{GetBrokerDetails.meeting_executive}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.calling_executive">
                    <span class="enq-title">Calling Executive</span>
                    <span class="enq-details">{{GetBrokerDetails.calling_executive}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.last_meeting_date">
                    <span class="enq-title">Last Meeting Date</span>
                    <span class="enq-details">{{GetBrokerDetails.last_meeting_date}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.empanelment_date">
                    <span class="enq-title">Empanelment Date</span>
                    <span class="enq-details">{{GetBrokerDetails.empanelment_date}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.next_call_date">
                    <span class="enq-title">NCD</span>
                    <span class="enq-details">{{GetBrokerDetails.next_call_date ? new Date(GetBrokerDetails.next_call_date).toLocaleString('en-In').split('/').join('-'):''}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.meeting_done">
                    <span class="enq-title">Meeting Done</span>
                    <span class="enq-details">{{GetBrokerDetails.meeting_done}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.meeting_scheduled">
                    <span class="enq-title">Meeting Scheduled</span>
                    <span class="enq-details">{{GetBrokerDetails.meeting_scheduled}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.site_visit_status">
                    <span class="enq-title">Site Visit Status</span>
                    <span class="enq-details">{{GetBrokerDetails.site_visit_status}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.sub_status_name">
                    <span class="enq-title">Sub Status</span>
                    <span class="enq-details">{{GetBrokerDetails.sub_status_name}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.categorization_code">
                    <span class="enq-title">Categorization Code</span>
                    <span class="enq-details">{{GetBrokerDetails.categorization_code}}</span>
                  </div>
                  <div class="col-6" v-if="GetBrokerDetails.rank">
                    <span class="enq-title">Categorization</span>
                    <span class="enq-details">{{GetBrokerDetails.rank}}</span>
                  </div>
                  <div class="col-12" v-if="GetBrokerDetails.comment">
                    <span class="enq-title">Comment</span>
                    <read-more more-str="read more" :text="GetBrokerDetails.comment" link="#" less-str="read less" :max-chars="50"></read-more>
                  </div>
                  <div class="col-12" v-if="GetBrokerDetails.comment_history">
                    <span class="enq-title">Comment History</span>
                    <read-more more-str="read more" :text="GetBrokerDetails.comment_history" link="#" less-str="read less" :max-chars="50"></read-more>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col-md-12 call-loading-holder">
                      <img width="100%" height="auto"  v-bind:src="CallStatus === 'dialing' ? PhoneCall.dialing : CallStatus === true ? PhoneCall.connected: CallStatus === false ? PhoneCall.failed: ''">
                  </div>
                  <div class="col-6 text-center">
                    <a v-if="GetBrokerDetails.contact_number"  @click="GetBrokerDetails.ctoc_enabled ? makeCall(GetBrokerDetails.id)  : dial(GetBrokerDetails.contact_number)">
                      <div>
                      <span class="icon icon-call">
                          <img src="@/assets/phone.svg" alt="">
                      </span>
                      <span class="enq-title">Mobile Number</span>
                      <span class="enq-details">{{GetBrokerDetails.contact_number}}</span>
                      </div>
                    </a>
                  </div>
                  <div class="col-6 text-center">
                    <a v-if="GetBrokerDetails.email" :href="`mailto:${GetBrokerDetails.email}`">
                      <span class="icon icon-call">
                        <img src="@/assets/email.svg" alt="" />
                      </span>
                      <span class="enq-title">Primary Email</span>
                      <span class="enq-details">{{GetBrokerDetails.email}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-btn">
              <div class="row pb-4">
                <div class="col-6 pl-2">
                  <b-btn class="btn btn-white btn-block" :to="{ name: 'CPCallLog', params: {  brokerid: GetBrokerDetails.id }}">
                    <span class="center-fix d-flex align-items-center justify-content-center">
                      <img src="@/assets/history.svg" alt="" class="mr-1" />History
                    </span>
                  </b-btn>
                </div>
                <div class="col-6 pl-2">
                  <b-btn class="btn btn-white btn-block" :to="{ name: 'EditCPBroker', params: {  brokerid: GetBrokerDetails.id }}">
                    <span class="center-fix d-flex align-items-center justify-content-center">
                      <img src="@/assets/edit-orange.svg" alt="" class="mr-1" />Edit
                    </span>
                  </b-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
export default {
  name: "CPBrokerDetails",
  components: {
    datetime: Datetime
  },
  data() {
    return {
      GetBrokerDetails: {},
      queryP: {},
      CallStatus: null,
      PhoneCall: {connected: require('@/assets/connected.gif'), dialing: require('@/assets/dialing.gif'), failed: require('@/assets/failed.gif')}
    };
  },
  mounted() {
    this.FetchBrokerDetails()
  },
  methods: {
    dial(phone) {
      window.location ='tel:'+ phone;
    },
    makeCall(id) {
        this.CallStatus = 'dialing'
        this.$axios.post(`brokers/make_call`, { id: id }).then((res) => {
          this.CallStatus = res.data.success
      });
    },
    FetchBrokerDetails() {
      this.queryP['broker_id'] = this.$route.params.brokerid;
      this.$axios.get(`brokers/${this.queryP.broker_id}/my_cps_detail`).then((res) => {
        this.GetBrokerDetails = res && res.data && res.data.broker;
        if (this.GetBrokerDetails.comment) {
          this.GetBrokerDetails.comment = this.GetBrokerDetails.comment.replaceAll('\n', '<br>')
        }
        if (this.GetBrokerDetails.comment_history) {
          this.GetBrokerDetails.comment_history = this.GetBrokerDetails.comment_history.replaceAll('\n', '<br>')
        }
      }).catch(err => console.log(err));
    }
  }
};
</script>
<style scoped>
.inner-page {
  margin-top: 60px;
}

.btn-secondary:hover {
  color: #233445;
  background-color: white;
  border-color: white;
}
</style>